export default "__VITE_ASSET__50024477__"